import { createContext, useContext } from 'react';

export interface TagConfigTagStyling {
  uniformColor?: string;
  borderSize?: number;
  fontSize?: number;
}

export interface TagConfig {
  tagVariant: string;
  tagColorMode: string;
  tagStyling: TagConfigTagStyling;
}

export const TagConfigContext = createContext<TagConfig | null>(null);

export const useTagConfig = () => {
  const context = useContext(TagConfigContext);
  if (!context) {
    throw new Error('useTagConfig must be used within a TagConfigProvider');
  }
  return context;
};
